import { render, staticRenderFns } from "./InplaceEditor.vue?vue&type=template&id=42852d48&scoped=true&"
import script from "./InplaceEditor.vue?vue&type=script&lang=js&"
export * from "./InplaceEditor.vue?vue&type=script&lang=js&"
import style0 from "./InplaceEditor.vue?vue&type=style&index=0&id=42852d48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42852d48",
  null
  
)

export default component.exports